import styled from 'styled-components';
import { ColumnDiv } from 'styles/elements/div';
import NHSLoginButton from 'assets/nhs/nhsLoginButton';
import InputBox from 'styles/elements/textarea';
import { H1 } from 'styles/elements/headers';
import { PrimaryButton, SecondaryButton } from '../../elements/buttons/primaryCare';

const Login = styled(ColumnDiv)``;

const LinkToNHSLogin = styled(NHSLoginButton).attrs({ as: 'a' })`
  color: white;
`;

const Textarea = styled(InputBox)`
  margin-top: 20px;
`;
const Confirm = styled(PrimaryButton)`
  margin-top: 0;
  margin-bottom: 1em;
`;

const Cancel = styled(SecondaryButton)`
  align-self: flex-start;
`;

const Text = styled.p`
  margin: 0.5em 0;
`;

const SubText = styled.p`
  margin: 1.5em 0;
  font-size: 16px;
`;

const List = styled.ul`
  padding-left: 20px;
  margin: 0.5em 0;
`;

const ListItem = styled.li`
  list-style-type: disc;
  margin-bottom: ${props => (props.isLastListItem ? '0' : '1em')}
`;

const NoConsentPaddedDiv = styled(ColumnDiv)`
    padding: 31px 14px 0 12px;
`;

const Link = styled.a``;

Login.NHSLoginButton = NHSLoginButton;
Login.LinkToNHSLogin = LinkToNHSLogin;
Login.Textarea = Textarea;
Login.Text = Text;
Login.Header = styled(H1)``;
Login.Confirm = Confirm;
Login.Cancel = Cancel;
Login.List = List;
Login.ListItem = ListItem;
Login.NoConsentPaddedDiv = NoConsentPaddedDiv;
Login.SubText = SubText;
Login.Link = Link;

export default Login;
